import { render, staticRenderFns } from "./IntegrationActionModal.vue?vue&type=template&id=6f4b4137&scoped=true"
import script from "./IntegrationActionModal.vue?vue&type=script&lang=js"
export * from "./IntegrationActionModal.vue?vue&type=script&lang=js"
import style0 from "./IntegrationActionModal.vue?vue&type=style&index=0&id=6f4b4137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b4137",
  null
  
)

export default component.exports